import { render, staticRenderFns } from "./PreviewFormDialog.vue?vue&type=template&id=c3523b9c&scoped=true&"
import script from "./PreviewFormDialog.vue?vue&type=script&lang=js&"
export * from "./PreviewFormDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3523b9c",
  null
  
)

export default component.exports